import request from '../Components/Functions/ajax/request'

import { erase } from './cartStoreFunctions'

import setServerStore from './setServerStore'

export default async function refreshServerStore ()
{
	try
	{
		var { status: shop_status } = await request('/shop/get-status')
		.config({ min_req_time: 0 })
		.post({ });
	}
	catch (update)
	{
		return;
	}

	setServerStore(shop_status);

	if (shop_status === 'suspended')
	{
		(async function cancel ()
		{
			try
			{
				await request('/cart/delete-cart')
				.config({ min_req_time: 0 })
				.post({ });
			}
			catch (update)
			{
				return;
			}

			erase();
		})();
	}
}